import React from 'react';
import IconButton from '@mui/material/IconButton';
import SettingsIcon from '@mui/icons-material/SettingsOutlined';
import ProjectsArchivedToggler from './ProjectsArchivedToggler';
import { DropdownMenu } from 'framework/ui/menu';

const ProjectsSettings = () => {
  return (
    <DropdownMenu
      popupId="journal-entry-settings"
      iconButton={
        <IconButton className="dropdown-toggle">
          <SettingsIcon />
        </IconButton>
      }
    >
      <ProjectsArchivedToggler />
    </DropdownMenu>
  );
};

export default ProjectsSettings;
